






























































































































































































import { CalculationParams } from "@/types";
import { defineComponent } from "@vue/composition-api";
import ApiClient from "@/services/api.client";
import { Container } from "@/components";
import {
  Calculation,
  CalculationBlock,
  CalculationUtils,
} from "@/models/Calculation";
import {
  ValidationError,
  ValidationResultBackend,
} from "@/models/ValidationError";
import LayoutDefault from "../layouts/LayoutDefault.vue";

// Calculation blocks
import {
  DelayedInvoice,
  FixedAmount,
  Percentage,
  DiscountByPercentage,
  RegistrationDiscount,
  ProrataDiscount,
  MinMax,
  SingleAmount,
  SharedInvoice,
  EnsureNetPrice,
  PricePerUnit,
  PricePerUnitManYears,
  ConflictfundMembershipDiscount,
  ConflictfundMembershipFee,
  ExistingMembershipExemption,
} from "@/components/CalculationTypes";
import { TextField } from "@/components";
import DeleteWithConfirmation from "@/components/DeleteWithConfirmation.vue";
import BlockChooser from "@/components/BlockChooser.vue";
import ChildDropdown from "./ChildDropdown.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { Actions, Getters, Mutations } from "@/store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import ErrorLabel from "@/components/ErrorLabel.vue";
import { getChildFederations } from "@/utils";
import { Federation } from "@/models/Federation";
import AssociationSelect from "@/components/AssociationSelect.vue";
import { BlockLabel, getBlockKey, getBlockLabel } from "@/models/BlockLabel";
export default defineComponent({
  name: "Calculation",
  components: {
    Container,
    BlockChooser,
    ChildDropdown,
    DeleteWithConfirmation,
    LoadingSpinner,
    FixedAmount,
    Percentage,
    DiscountByPercentage,
    RegistrationDiscount,
    ProrataDiscount,
    ExistingMembershipExemption,
    MinMax,
    PricePerUnit,
    PricePerUnitManYears,
    SingleAmount,
    SharedInvoice,
    EnsureNetPrice,
    ConflictfundMembershipDiscount,
    ConflictfundMembershipFee,
    DelayedInvoice,
    ErrorLabel,
    AssociationSelect,
    LayoutDefault,
    TextField,
  },
  data() {
    return {
      isLoading: false,
      saving: false,
      blocks: [] as Array<CalculationBlock>,
      validationErrors: [] as Array<ValidationError>,
      calculationType: "",
      year: 0,
      nhoNumber: 0,
      organizationNumber: -1,
      associationName: "",
      customCalculationText: "",
      highestIntervalValue: 0,
      isActive: false,
      selectedChild: 0,
      childFederations: [] as Array<Federation>,
      childOrganizationCalculations: [] as Array<Calculation>,
      failedToFindCalculation: false,
      childPriorityClass: 0,
      membershipType: 0,
    };
  },
  computed: {
    ...mapGetters([
      Getters.ASSOCIATIONS,
      Getters.OPEN_CALCULATION,
      Getters.CALCULATIONS,
    ]),
    isSaveDisabled(): boolean {
      return this.hasUnsavedChanges || this.hasInvalidOrgNumber;
    },
    hasUnsavedChanges(): boolean {
      return this.openCalculation.blocks.some(
        (x: CalculationBlock) => x.isExpanded
      );
    },
    hasUnsavedComponentChanges(): boolean {
      return this.isActive !== this.openCalculation.isActive;
    },
    hasInvalidOrgNumber(): boolean {
      return isNaN(this.organizationNumber) || this.organizationNumber < 1;
    },
    isCreatingNewCalculation(): boolean {
      return this.isChildSelected() && !this.childCalculationExists();
    },
    toggleActiveDisplay(): string {
      return this.isActive ? "Deaktiver" : "Aktiver";
    },
  },
  watch: {
    associations(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.childFederations = getChildFederations(
          this.associations,
          this.nhoNumber
        );
      }
    },
    calculations(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadCalculation();
      }
    },
  },
  created() {
    if (this.calculations == undefined) {
      this.isLoading = true;
      this.fetchCalculations();
    }
    if (this.associations == undefined) {
      this.fetchFederations();
    }
  },
  mounted() {
    if (this.isValidQueryParameters()) {
      this.loadCalculation();
    }
  },
  methods: {
    ...mapActions([Actions.FETCH_CALCULATIONS, Actions.FETCH_FEDERATIONS]),
    ...mapMutations([Mutations.SET_OPEN_CALCULATION]),
    getChildFederations: getChildFederations,
    getSortedBlocks() {
      var sortedBlocks = this.blocks.map((block) => block);
      sortedBlocks.sort((a, b) => {
        const displayNameA = getBlockLabel(a.type);
        const displayNameB = getBlockLabel(b.type);
        return displayNameA > displayNameB
          ? 1
          : displayNameB > displayNameA
          ? -1
          : 0;
      });

      return sortedBlocks;
    },
    getErrorBlockLabel(type: string): string {
      return getBlockLabel(type);
    },
    getUniqueBlockKey(blockId: number): string {
      const key = `block_${
        this.selectedChild !== undefined ? this.selectedChild : ""
      }${blockId}`;

      return key;
    },
    loadCalculation(): void {
      const { org, type, year, childOrganization, membershipType } =
        this.getQueryParameters();

      let openCalculation: Calculation = Object.freeze(this.openCalculation);

      const isCreatingNewCalculation =
        parseInt(org) === openCalculation?.nhoNumber &&
        type === openCalculation?.calculationType &&
        parseInt(membershipType) === openCalculation?.membershipType &&
        year.toString() === openCalculation?.year.toString();
      console.log(isCreatingNewCalculation);
      const calculation = isCreatingNewCalculation
        ? openCalculation
        : this.getCalculationFromQueryParams(
            parseInt(year),
            type,
            parseInt(org),
            membershipType
          );

      if (calculation == null) return;

      this.failedToFindCalculation = false;
      this.isLoading = false;

      this.year = calculation.year;
      this.associationName = calculation.associationName;
      this.membershipType = calculation.membershipType;
      this.nhoNumber = calculation.nhoNumber;
      this.organizationNumber = calculation.organizationNumber;
      this.customCalculationText = calculation.customCalculationText;
      this.childPriorityClass = calculation.childPriorityClass;
      this.calculationType = calculation.calculationType;
      this.blocks = calculation.blocks.map((block) => block);
      this.blocks.forEach((block, index) => {
        block.blockId = index;
      });
      this.isActive = calculation.isActive;
      this.childOrganizationCalculations =
        calculation.childOrganizationCalculations;

      if (childOrganization) {
        this.selectedChild = parseInt(childOrganization);
        this.onChildDropdownChange(this.selectedChild);
      } else {
        this.setOpenCalculation(calculation);
      }

      this.childFederations = getChildFederations(
        this.associations,
        this.nhoNumber
      );
    },
    toggleActive(): void {
      this.isActive = !this.isActive;
    },
    isValidQueryParameters(): boolean {
      const { org, type, year, membershipType } = this.$route.query;
      const isValid =
        org !== null &&
        typeof org === "string" &&
        type !== null &&
        typeof type === "string" &&
        year !== null &&
        typeof year === "string" &&
        membershipType !== null &&
        typeof membershipType === "string";
      return isValid;
    },
    getQueryParameters(): CalculationParams {
      const { org, type, year, childOrganization, membershipType } =
        this.$route.query;

      return {
        org: org !== null && typeof org === "string" ? org : "",
        type: type !== null && typeof type === "string" ? type : "",
        year: year !== null && typeof year === "string" ? year : "",
        membershipType:
          membershipType !== null && typeof membershipType === "string"
            ? membershipType
            : "0",
        childOrganization:
          childOrganization !== null && typeof childOrganization === "string"
            ? childOrganization
            : null,
      };
    },
    getInvalidQueryMessage(): string {
      const { org, type, year, membershipType } = this.$route.query;

      return `Finner ikke kalkulasjonen for

      Organisasjonsnummer = ${org}
      Kontingenttype = ${type}
      År = ${year}
      Medlemskapstype = ${membershipType}

      1. Sjekk at urlen slutter på /calculation?org=ORGANISASJONSNUMMER&type=KONTINGENTTYPE&year=ÅR
      2. Oppdater siden`;
    },
    getCalculationTypeLabel(): string {
      return this.calculationType.toLowerCase() === "contingent"
        ? "Kontingent"
        : "Serviceavgift";
    },
    getMembershipTypeLabel(): string {
      return this.membershipType === 0
        ? "Ordinært Medlemskap"
        : this.membershipType === 1
        ? "Fagmedlemskap"
        : "Ekstraordinært Medlemskap";
    },
    onChildDropdownChange(selectedChild: number | null) {
      selectedChild = selectedChild ?? 0;

      this.selectedChild = selectedChild;

      const { childOrganization } = this.getQueryParameters();
      if (childOrganization !== selectedChild.toString()) {
        let updatedQueryParams = {
          query: {
            ...this.$route.query,
            childOrganization: selectedChild.toString(),
          },
        } as any;

        if (selectedChild === 0)
          delete updatedQueryParams.query.childOrganization;

        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.$router.replace(updatedQueryParams).catch(() => {});
      }

      const calculationToLoad = this.getCalculationToLoad();

      this.blocks = calculationToLoad.blocks.map((block) => block);
      this.isActive = calculationToLoad.isActive;
      this.organizationNumber = calculationToLoad.organizationNumber;
      this.customCalculationText = calculationToLoad.customCalculationText;
      this.childPriorityClass = calculationToLoad.childPriorityClass;
      this.membershipType = calculationToLoad.membershipType;

      const updatedOpenCalculation = {
        ...this.openCalculation,
        blocks: calculationToLoad.blocks,
        isActive: calculationToLoad.isActive,
      };
      this.setOpenCalculation(updatedOpenCalculation);
    },
    getCalculationToLoad(): Calculation {
      let calculation = null;

      if (this.childCalculationExists())
        calculation = this.getSelectedChildCalculation();
      else calculation = this.getMainCalculation();

      if (calculation == null) throw new Error("Calculation was null");

      return calculation;
    },
    getCalculationFromQueryParams(
      year: number,
      type: string,
      organizationNumber: number,
      membershipType: string
    ): Calculation | undefined {
      const newCalculation = (this.calculations as Array<Calculation>)?.find(
        (calc) =>
          calc.nhoNumber === organizationNumber &&
          calc.calculationType === type &&
          calc.year === year &&
          calc.membershipType === parseInt(membershipType)
      );

      if (newCalculation === undefined) {
        this.failedToFindCalculation = true;
      }

      return newCalculation;
    },
    getMainCalculation(): Calculation | null {
      const calculation = (this.calculations as Array<Calculation>)?.find(
        (calc) =>
          calc.nhoNumber === this.nhoNumber &&
          calc.calculationType === this.calculationType &&
          calc.year === this.year &&
          calc.membershipType === this.membershipType
      );

      if (calculation === undefined) return null;

      return calculation;
    },
    getChildOrganizationName(): string {
      return this.getSelectedChildOrganization()?.name ?? "";
    },
    getSelectedChildOrganization(): Federation | undefined {
      const selectedChild =
        (this.associations as Array<Federation>)?.find(
          (o) => o.nhoNumber == this.selectedChild
        ) || undefined;
      return selectedChild;
    },
    getSelectedChildCalculation(): Calculation | undefined {
      const selectedChild = this.childOrganizationCalculations.find(
        (o) => o.childNhoNumber == this.selectedChild
      );
      return selectedChild;
    },
    isChildSelected(): boolean {
      return this.getSelectedChildOrganization() !== undefined;
    },
    childCalculationExists(): boolean {
      return CalculationUtils.hasChildCalculation(
        this.childOrganizationCalculations,
        this.selectedChild
      );
    },
    getNextBlockIndex(): number {
      const indexes = this.blocks.map((block) => block.blockId);
      const maxIndex = indexes.length ? Math.max(...indexes) : 0;
      return maxIndex + 1;
    },
    addBlock(blockKey: string) {
      const newBlock = {
        type: blockKey,
        blockId: this.getNextBlockIndex(),
        isExpanded: true,
      } as CalculationBlock;
      this.blocks.push(newBlock);
      var calculation = this.getCurrentCalculationObject();
      this.setOpenCalculation(calculation);
    },
    setHighestIntervalValue(potentialValue: number) {
      if (potentialValue > this.highestIntervalValue) {
        this.highestIntervalValue = potentialValue;
      }
    },
    getBlockIndex(blockId: number) {
      var block = this.blocks.find((item) => item.blockId === blockId);
      if (block == undefined) {
        var err = `ERROR: Could not find block with id ${blockId}`;
        console.log(err);
        throw new TypeError(err);
      }

      return this.blocks.indexOf(block);
    },
    setBlockExpanded(blockId: number) {
      var index = this.getBlockIndex(blockId);

      var calculation = this.getCurrentCalculationObject();
      calculation.blocks[index].isExpanded = true;

      this.setOpenCalculation(calculation);
    },
    updateBlock(updatedBlock: CalculationBlock) {
      var index = this.getBlockIndex(updatedBlock.blockId);

      var calculation = this.getCurrentCalculationObject();
      calculation.blocks[index].data = updatedBlock;
      calculation.blocks[index].isExpanded = false;

      this.removeValidationErrorsForBlock(updatedBlock.blockId);

      this.setOpenCalculation(calculation);
    },
    removeBlock(block: CalculationBlock) {
      this.removeValidationErrorsForBlock(block.blockId);
      let index = this.blocks.indexOf(block);
      this.blocks.splice(index, 1);
    },
    removeValidationErrorsForBlock(blockId: number) {
      this.validationErrors = this.validationErrors.filter(
        (error) => error.blockId !== blockId
      );
    },
    getValidationErrorsForBlock(blockId: number) {
      return this.validationErrors.filter(
        (error) => error.blockId === blockId
      );
    },
    redirectToOtherContingentType(): void {
      const path = `calculation?org=${this.nhoNumber}&type=${
        this.calculationType === "Contingent" ? "ServiceFee" : "Contingent"
      }&year=${this.year}&childOrganization=${
        this.isChildSelected() && this.childCalculationExists()
          ? this.selectedChild
          : 0
      }`;
      this.$router
        .push({
          path,
        })
        .then(() => {
          this.$router.go(0);
        });
    },
    saveCalculation() {
      this.saving = true;

      let openCalculation = this.getCurrentCalculationObject();
      ApiClient.SaveCalculation(openCalculation)
        .then(() => {
          this.$toast.success("Beregning lagret!");
          this.saving = false;
          this.validationErrors = [];

          if (!this.isChildSelected()) {
            var mainCalc = this.getMainCalculation();
            if (mainCalc) {
              mainCalc.isActive = openCalculation.isActive;
              mainCalc.blocks = openCalculation.blocks;
            }

            this.setOpenCalculation(openCalculation);
            return;
          }

          let mainCalculation = this.openCalculation as Calculation;
          let updatedChildCalcs: Calculation[] =
            mainCalculation.childOrganizationCalculations;

          const shouldUpdateExistingChildCalculation =
            this.childCalculationExists();

          if (shouldUpdateExistingChildCalculation) {
            updatedChildCalcs =
              mainCalculation.childOrganizationCalculations.map(
                (calculation: Calculation) => {
                  if (calculation.childNhoNumber === this.selectedChild) {
                    return openCalculation;
                  }
                  return calculation;
                }
              );
          } else {
            updatedChildCalcs = [
              ...mainCalculation.childOrganizationCalculations,
              openCalculation,
            ];
          }

          this.childOrganizationCalculations = updatedChildCalcs;
          mainCalculation.childOrganizationCalculations = updatedChildCalcs;
          mainCalculation.isActive = this.isActive;
          this.setOpenCalculation(mainCalculation);
        })
        .catch((error) => {
          this.saving = false;

          if (
            error.response?.status !== 400 ||
            !Array.isArray(error.response.data)
          ) {
            this.$toast.error("En feil oppsto under lagring!");
            return;
          }

          this.validationErrors = error.response.data.map(
            (validationResult: ValidationResultBackend) => {
              var splittedResult = validationResult.errorMessage.split(".");
              return {
                blockId: parseInt(splittedResult[0]),
                errorType: splittedResult[1],
                message: splittedResult[2],
              };
            }
          );

          this.$toast.error(
            "Lagring feilet. Oppdater ugyldige blokker og prøv igjen"
          );

          const blocksToExpand = this.validationErrors.map((error) =>
            this.getBlockIndex(error.blockId)
          );

          blocksToExpand.forEach((blockId) => this.setBlockExpanded(blockId));
        });
    },
    getCurrentCalculationObject(): Calculation {
      return {
        nhoNumber: this.nhoNumber,
        organizationNumber: this.organizationNumber,
        customCalculationText: this.customCalculationText,
        childNhoNumber: this.selectedChild,
        childPriorityClass: this.childPriorityClass,
        associationName: this.associationName,
        year: this.year,
        blocks: this.blocks,
        calculationType: this.calculationType,
        isActive: this.isActive,
        childOrganizationCalculations: this.childOrganizationCalculations,
        membershipType: this.membershipType,
      };
    },
  },
});
